module.exports = __webpack_public_path__ + "img/pd.1731d7ea.svg";